(() => {
  const selector = '.announcement-bar[data-crux-promo-campaign-end]';
  const pad = (value) => String(value).padStart(2, '0');
  function update(bar) {
    const urgency = Date.parse(bar.dataset.cruxPromoUrgencyEnd || '');
    const campaign = Date.parse(bar.dataset.cruxPromoCampaignEnd || '');
    const now = Date.now();
    const countdown = bar.querySelector('.crux-promo-countdown');
    if (!Number.isFinite(campaign)) return;
    const target = Number.isFinite(urgency) && now < urgency ? urgency : campaign;
    const remaining = Math.max(0, target - now);
    const seconds = Math.floor(remaining / 1000);
    const values = { days: Math.floor(seconds / 86400), hours: Math.floor((seconds % 86400) / 3600), minutes: Math.floor((seconds % 3600) / 60), seconds: seconds % 60 };
    if (countdown) {
      Object.entries(values).forEach(([unit, value]) => { const node = countdown.querySelector(`[data-crux-countdown-${unit}]`); if (node) node.textContent = pad(value); });
      countdown.setAttribute('aria-label', now < urgency ? 'Offer countdown to the next promotion phase' : 'Offer countdown to campaign end');
    }
    if (now >= campaign) {
      bar.classList.add('crux-promo-ended');
      bar.querySelectorAll('.crux-promo-strip').forEach((node) => { node.hidden = true; });
      const key = 'crux-campaign-ended-' + bar.dataset.cruxPromoCampaignEnd;
      if (!sessionStorage.getItem(key)) { sessionStorage.setItem(key, '1'); window.location.reload(); }
    } else {
      bar.classList.remove('crux-promo-ended');
    }
  }
  function expirePrices() {
    document.querySelectorAll('[data-crux-campaign-price]').forEach((node) => {
      const end = Date.parse(node.dataset.cruxCampaignEnd || '');
      if (!Number.isFinite(end) || Date.now() < end || node.dataset.cruxExpired === 'true') return;
      const original = node.querySelector('[data-crux-original-price]');
      if (original) {
        const regular = document.createElement('span');
        regular.textContent = original.textContent;
        original.replaceWith(regular);
      }
      node.querySelectorAll('[data-crux-discount-price], [data-crux-discount-badge]').forEach((item) => { item.hidden = true; });
      node.dataset.cruxExpired = 'true';
    });
  }
  function updateAll() { document.querySelectorAll(selector).forEach(update); expirePrices(); }
  if (window.__cruxPromoCountdownTimer) clearInterval(window.__cruxPromoCountdownTimer);
  updateAll(); window.__cruxPromoCountdownTimer = setInterval(updateAll, 1000);
  document.addEventListener('shopify:section:load', updateAll);
})();